import React from 'react';
import styled from 'styled-components';
import { startCase } from 'lodash-es';
import { Icon } from '../../../Atoms/Icon';
const StyledContainer = styled.div `
  display: flex;
  align-items: center;
  height: 3.666666667rem;
  padding: 1rem;
  box-sizing: border-box;
  cursor: pointer;

  &:hover {
    background-color: rgba(225, 228, 235, 0.44);
  }
`;
const StyledIcon = styled(Icon) `
  margin-right: 0.916666667rem;
  font-size: 1.416666667rem;
  font-weight: 700;
`;
const StyledLabel = styled.span `
  font-size: 1.166666667rem;
  font-weight: 700;
`;
const Option = ({ className, option: { name, label, icon }, onClick, }) => (React.createElement(StyledContainer, { className: className, onClick: () => onClick(name) },
    icon && React.createElement(StyledIcon, { icon: icon }),
    React.createElement(StyledLabel, null, label || startCase(name))));
export default Option;
